import { api } from '../affWebhooksApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postAffWebhooksV1ContractsUpdateStatus: build.mutation({
            query: (queryArg) => ({
                url: `/aff_webhooks/v1/contracts/update_status`,
                method: 'POST',
                body: queryArg.postAffWebhooksV1ContractsUpdateStatus,
            }),
        }),
        postAffWebhooksV1CreditApplicationsUpdateStatus: build.mutation({
            query: (queryArg) => ({
                url: `/aff_webhooks/v1/credit_applications/update_status`,
                method: 'POST',
                body: queryArg.postAffWebhooksV1CreditApplicationsUpdateStatus,
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as affWebhooksApi };
export const { usePostAffWebhooksV1ContractsUpdateStatusMutation, usePostAffWebhooksV1CreditApplicationsUpdateStatusMutation, } = injectedRtkApi;
